import { fetcher } from "../../utils/fetcher.js";

// The user's upcoming reminder on a task or list item ({ reminder } or
// { reminder: null }). target: { taskId } or { todoListId, listItemId }
export const getReminder = (target) =>
  fetcher.get(`/api/reminders?${new URLSearchParams(target)}`);
